import { Fragment } from "react";

import styles from "./B2cPage.module.scss";

import Card from '../Common/Card';
import ImageSlider from "../Common/ImageSlider";
import Button from '../Common/Button';
import Testimonial from "../Common/Testimonial";
import Thumbnail from "../Common/Thumbnail";
import PageDivider from "../Common/PageDivider";
import Typography from "../Common/Typography";

import { Position, Orientation, FlexAlignment, ImageLoading, TypographyVariants, TypographyFonts, getUrlForAssets } from "../Contracts";

export const B2cPage = (props) => {

  const { b2cPageData = {} } = props;

  const {
    bookOrderSection = {},
    customerReviewSection = {},
    personalShoppingSection = {},
    whatsAppSection = {},
    storeSetupSection = {},
    expertSection = {}
  } = b2cPageData;

  const renderVirtualStoreContainer = () => {
    const { cardTitle, cardSubTitle, cardDescription, cardImageUrl, cardImageUrlFallback, cardImageAlt, cardImageHeight, cardImageWidth, buttonsList = [] } = bookOrderSection || {};
    return (
      <section className={`${styles.VirtualStoreContainer} page-section-padding`}>
        <Card
          orientation={Orientation.HORIZONTAL}
          imagePosition={{
            mobile: Position.LEFT,
            desktop: Position.RIGHT
          }}
          alignment={{
            justifyContent: FlexAlignment.FLEX_START,
            alignItems: FlexAlignment.CENTER
          }}
          cardImage={{
            className: styles.B2cPageCardImage,
            imageUrl: cardImageUrl,
            imageUrlFallback: cardImageUrlFallback,
            imageAlt: cardImageAlt,
            imageHeight: cardImageHeight,
            imageWidth: cardImageWidth,
            imageLoading: ImageLoading.EAGER
          }}
          cardContent={{
            className: styles.B2cPageCardContent,
            title: (
              <Fragment>
                {cardTitle && (
                  <Typography
                    variant={TypographyVariants.HEADING_1}
                    className={styles.B2cPageCardSubTitle}
                    style={{ fontSize: '14px', color: 'var(--subHeading)' }}
                    tabletStyle={{ fontSize: '14px' }}
                    mobileStyle={{ fontSize: '14px' }}
                    dangerouslySetInnerHTML={{ __html: cardTitle }}
                  />
                )}
                {cardSubTitle && (
                  <Typography
                    variant={TypographyVariants.HEADING_2}
                    className={styles.B2cPageCardTitle}
                    style={{ fontSize: '42px', fontWeight: '700', color: 'var(--black)', lineHeight: '1.3', marginTop: '12px' }}
                    tabletStyle={{ fontSize: '36px' }}
                    mobileStyle={{ fontSize: '30px' }}
                    dangerouslySetInnerHTML={{ __html: cardSubTitle }}
                  />
                )}
              </Fragment>
            ),
            description: (
              <Fragment>
                {cardDescription && (
                  <Typography
                    variant={TypographyVariants.PARAGRAPH}
                    style={{ fontSize: '26px', fontWeight: '400', color: 'var(--cardDescription)', marginTop: '18px' }}
                    tabletStyle={{ fontSize: '24px', marginTop: '18px' }}
                    mobileStyle={{ fontSize: '22px', marginTop: '18px' }}
                    className={styles.B2cPageCardDescription}
                    dangerouslySetInnerHTML={{ __html: cardDescription }}
                  />
                )}
                {buttonsList.length > 0 && (
                  <div className={styles.B2cPageCardButtonsContainer}>
                    {buttonsList.map((button, index) => {
                      const { type, htmlType, linkUrl, openInNewTab, text, onClick } = button;
                      return (
                        <Button key={index} type={type} htmlType={htmlType} className={styles.B2cPageCardButton} linkUrl={linkUrl} openInNewTab={openInNewTab} onClick={onClick}>{text}</Button>
                      );
                    })}
                  </div>
                )}
              </Fragment>
            )
          }}
          className={styles.B2cPageCard}
        />
      </section>
    );
  };

  const renderCustomerReviewContainer = () => {
    const { testimonialsList = [] } = customerReviewSection || {};
    if (testimonialsList.length === 0) {
      return null;
    }
    const renderSlide = (testimonial, index) => {
      const { thumbnailUrl, thumbnailUrlFallback, thumbnailHeight, thumbnailWidth, title, subTitle, description, customerName, cardVideoTagName, cardVideoUrl, cardVideoAlt, cardVideoHeight, cardVideoWidth, cardVideoPosterUrl, cardVideoPosterUrlFallback, cardVideoPosterHeight, cardVideoPosterWidth, cardVideoMuted, cardVideoAutoplay, cardVideoControls, cardVideoDisablePictureInPicture, cardVideoAllowFullScreen, cardVideoLoop } = testimonial;
      return (
        <Card
          key={index}
          orientation={Orientation.HORIZONTAL}
          imagePosition={{
            mobile: Position.LEFT,
            desktop: Position.RIGHT
          }}
          alignment={{
            justifyContent: FlexAlignment.FLEX_START,
            alignItems: FlexAlignment.CENTER
          }}
          cardImage={{
            className: styles.B2cPageCardImage,
            videoTagName: cardVideoTagName,
            videoUrl: cardVideoUrl,
            videoAlt: cardVideoAlt,
            videoHeight: cardVideoHeight,
            videoWidth: cardVideoWidth,
            videoPosterUrl: cardVideoPosterUrl,
            videoPosterUrlFallback: cardVideoPosterUrlFallback,
            videoPosterHeight: cardVideoPosterHeight,
            videoPosterWidth: cardVideoPosterWidth,
            videoMuted: cardVideoMuted,
            videoAutoplay: cardVideoAutoplay,
            videoControls: cardVideoControls,
            videoDisablePictureInPicture: cardVideoDisablePictureInPicture,
            videoAllowFullScreen: cardVideoAllowFullScreen,
            videoLoop: cardVideoLoop,
            videoLoading: ImageLoading.LAZY
          }}
          cardContent={{
            className: styles.B2cPageCardContent,
            title: (
              <Testimonial
                thumbnail={
                  <Thumbnail
                    imageUrl={thumbnailUrl}
                    imageUrlFallback={thumbnailUrlFallback}
                    imageHeight={thumbnailHeight}
                    imageWidth={thumbnailWidth}
                    style={{ objectFit: 'contain' }}
                    size={{ height: 90, width: 90 }}
                    mobileSize={{ height: 64, width: 64 }}
                  />
                }
                name={
                  title && (<Typography
                    style={{ fontSize: '26px', fontWeight: '700' }}
                    tabletStyle={{ fontSize: '24px' }}
                    mobileStyle={{ fontSize: '22px' }}
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                  )}
                company={
                  subTitle && (<Typography
                    style={{ fontSize: '26px', fontWeight: '400' }}
                    tabletStyle={{ fontSize: '24px' }}
                    mobileStyle={{ fontSize: '22px' }}
                    dangerouslySetInnerHTML={{ __html: subTitle }}
                  />
                  )
                }
                className={styles.B2cPageCardTitle}
              />
            ),
            description: (
              <Fragment>
                {description &&
                  (<Typography
                    variant={TypographyVariants.PARAGRAPH}
                    className={styles.B2cPageCardDescription}
                    style={{ fontSize: '26px', fontWeight: '400', color: 'var(--black)', marginTop: '36px' }}
                    tabletStyle={{ fontSize: '24px', marginTop: '24px' }}
                    mobileStyle={{ fontSize: '22px', marginTop: '24px' }}
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                  )}
                {customerName &&
                  (<Typography
                    variant={TypographyVariants.PARAGRAPH}
                    className={styles.CustomerReviewName}
                    style={{ fontSize: '26px', fontWeight: '400', color: 'var(--black)', marginTop: '24px' }}
                    tabletStyle={{ fontSize: '24px', marginTop: '24px' }}
                    mobileStyle={{ fontSize: '22px', marginTop: '24px' }}
                    dangerouslySetInnerHTML={{ __html: customerName }}
                  />
                  )}
              </Fragment>
            )
          }}
          className={styles.B2cPageCard}
        />
      );
    };
    return (
      <section className={`${styles.CustomerReviewContainer} page-section-padding`}>
        {testimonialsList.length > 0 && (
          <ImageSlider
            autoplay={false}
            dots={false}
            arrows={false}
            slidesToShow={1}
            slidesToScroll={1}
            lazyLoad={false}
            slides={
              testimonialsList.map((testimonial, index) => {
                return renderSlide(testimonial, index);
              })
            }
            className={`${styles.B2cPageCardSlider} testimonial-slider`}
          />
        )}
      </section>
    );
  };

  const renderPersonalShoppingContainer = () => {
    const { sectionTitle, sectionSubTitle, cardTitle, cardDescription, cardImageUrl, cardImageUrlFallback, cardImageAlt, cardImageHeight, cardImageWidth, featuresList = [] } = personalShoppingSection || {};
    return (
      <section className={`${styles.PersonalShoppingContainer} page-section-padding`}>
        {sectionTitle && (
          <Typography
            variant={TypographyVariants.HEADING_2}
            style={{ fontSize: '36px', fontFamily: TypographyFonts.LIBRE_BODONI, fontStyle: 'italic', textAlign: 'center' }}
            tabletStyle={{ fontSize: '32px' }}
            mobileStyle={{ fontSize: '26px' }}
            dangerouslySetInnerHTML={{ __html: sectionTitle }}
          />
        )}
        {sectionSubTitle && (
          <Typography
            variant={TypographyVariants.HEADING_3}
            style={{ fontSize: '26px', textAlign: 'center', marginTop: '24px' }}
            tabletStyle={{ fontSize: '24px', marginTop: '24px' }}
            mobileStyle={{ fontSize: '22px', marginTop: '18px' }}
            dangerouslySetInnerHTML={{ __html: sectionSubTitle }}
          />
        )}
        <Card
          orientation={Orientation.HORIZONTAL}
          imagePosition={{
            mobile: Position.LEFT,
            desktop: Position.RIGHT
          }}
          alignment={{
            justifyContent: FlexAlignment.FLEX_START,
            alignItems: FlexAlignment.CENTER
          }}
          cardImage={{
            className: styles.B2cPageCardImage,
            imageUrl: cardImageUrl,
            imageUrlFallback: cardImageUrlFallback,
            imageAlt: cardImageAlt,
            imageHeight: cardImageHeight,
            imageWidth: cardImageWidth
          }}
          cardContent={{
            className: styles.B2cPageCardContent,
            title: (
              cardTitle ? (
                <Typography
                  variant={TypographyVariants.HEADING_4}
                  className={styles.B2cPageCardTitle}
                  style={{ fontSize: '30px', fontWeight: '700', color: 'var(--black)' }}
                  tabletStyle={{ fontSize: '28px' }}
                  mobileStyle={{ fontSize: '26px' }}
                  dangerouslySetInnerHTML={{ __html: cardTitle }}
                />
              ) : null
            ),
            description: (
              <Fragment>
                {cardDescription && (
                  <Typography
                    variant={TypographyVariants.HEADING_5}
                    style={{ fontSize: '26px', color: 'var(--black)', fontFamily: TypographyFonts.LIBRE_BODONI, fontStyle: 'italic', lineHeight: '32px', marginTop: '24px' }}
                    tabletStyle={{ fontSize: '24px', lineHeight: '30px', marginTop: '18px' }}
                    mobileStyle={{ fontSize: '22px', lineHeight: '28px', marginTop: '12px' }}
                    className={styles.B2cPageCardDescription}
                    dangerouslySetInnerHTML={{ __html: cardDescription }}
                  />
                )}
                {featuresList.length > 0 && (
                  <div className={styles.B2cPageFeaturesContainer}>
                    <div className={styles.B2cPageFeatureListContainer}>
                      {featuresList.map((feature, index) => {
                        const { cardImageUrl, cardImageHeight, cardImageWidth, cardTitle } = feature;
                        return (
                          <div key={index} className={styles.B2cPageFeatureListItemContainer}>
                            {cardImageUrl && (
                              <img src={getUrlForAssets(cardImageUrl)} alt={cardTitle} className={styles.B2cPageFeatureListItemIcon} loading={ImageLoading.LAZY} height={cardImageHeight || "100%"} width={cardImageWidth || "100%"} />
                            )}
                            {cardTitle && (
                              <Typography variant={TypographyVariants.PARAGRAPH} className={styles.B2cPageFeatureListItemText} dangerouslySetInnerHTML={{ __html: cardTitle }} />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </Fragment>
            )
          }}
          className={styles.B2cPageCard}
        />
      </section>
    );
  };

  const renderWhatsAppCommerceContainer = () => {
    const { cardTitle, cardDescription, cardImageUrl, cardImageUrlFallback, cardImageAlt, cardImageHeight, cardImageWidth, featuresList = [] } = whatsAppSection || {};
    return (
      <section className={`${styles.WhatsappCommerceContainer} page-section-padding`}>
        <Card
          orientation={Orientation.HORIZONTAL}
          imagePosition={{
            mobile: Position.LEFT,
            desktop: Position.LEFT
          }}
          alignment={{
            justifyContent: FlexAlignment.FLEX_START,
            alignItems: FlexAlignment.FLEX_START
          }}
          cardImage={{
            className: styles.B2cPageCardImage,
            imageUrl: cardImageUrl,
            imageUrlFallback: cardImageUrlFallback,
            imageAlt: cardImageAlt,
            imageHeight: cardImageHeight,
            imageWidth: cardImageWidth
          }}
          cardContent={{
            className: styles.B2cPageCardContent,
            title: (
              cardTitle ? (
                <Typography
                  variant={TypographyVariants.HEADING_4}
                  className={styles.B2cPageCardTitle}
                  style={{ fontSize: '30px', fontWeight: '700', color: 'var(--black)' }}
                  tabletStyle={{ fontSize: '28px' }}
                  mobileStyle={{ fontSize: '26px' }}
                  dangerouslySetInnerHTML={{ __html: cardTitle }}
                />
              ) : null
            ),
            description: (
              <Fragment>
                {cardDescription && (
                  <Typography
                    variant={TypographyVariants.HEADING_5}
                    style={{ fontSize: '26px', color: 'var(--black)', fontFamily: TypographyFonts.LIBRE_BODONI, fontStyle: 'italic', lineHeight: '32px', marginTop: '24px' }}
                    tabletStyle={{ fontSize: '24px', lineHeight: '30px', marginTop: '18px' }}
                    mobileStyle={{ fontSize: '22px', lineHeight: '28px', marginTop: '12px' }}
                    className={styles.B2cPageCardDescription}
                    dangerouslySetInnerHTML={{ __html: cardDescription }}
                  />
                )}
                {featuresList.length > 0 && (
                  <div className={styles.B2cPageFeaturesContainer}>
                    <div className={styles.B2cPageFeatureListContainer}>
                      {featuresList.map((feature, index) => {
                        const { cardImageUrl, cardImageHeight, cardImageWidth, cardTitle } = feature;
                        return (
                          <div key={index} className={styles.B2cPageFeatureListItemContainer}>
                            {cardImageUrl && (
                              <img src={getUrlForAssets(cardImageUrl)} alt={cardTitle} className={styles.B2cPageFeatureListItemIcon} loading={ImageLoading.LAZY} height={cardImageHeight || "100%"} width={cardImageWidth || "100%"} />
                            )}
                            {cardTitle && (
                              <Typography variant={TypographyVariants.PARAGRAPH} className={styles.B2cPageFeatureListItemText} dangerouslySetInnerHTML={{ __html: cardTitle }} />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </Fragment>
            )
          }}
          className={styles.B2cPageCard}
        />
      </section>
    );
  };

  const renderBlazingFastStoreSetupContainer = () => {
    const { cardTitle, cardDescription, cardImageUrl, cardImageUrlFallback, cardImageAlt, cardImageHeight, cardImageWidth, featuresList = [] } = storeSetupSection || {};
    return (
      <section className={`${styles.BlazingFastStoreSetupContainer} page-section-padding`}>
        <Card
          orientation={Orientation.HORIZONTAL}
          imagePosition={{
            mobile: Position.LEFT,
            desktop: Position.RIGHT
          }}
          alignment={{
            justifyContent: FlexAlignment.FLEX_START,
            alignItems: FlexAlignment.STRETCH
          }}
          cardImage={{
            className: styles.B2cPageCardImage,
            imageUrl: cardImageUrl,
            imageUrlFallback: cardImageUrlFallback,
            imageAlt: cardImageAlt,
            imageHeight: cardImageHeight,
            imageWidth: cardImageWidth
          }}
          cardContent={{
            className: styles.B2cPageCardContent,
            title: (
              <Fragment>
                {cardTitle && (
                  <Typography
                    variant={TypographyVariants.HEADING_2}
                    className={styles.B2cPageCardTitle}
                    style={{ fontSize: '36px', fontWeight: '500', fontFamily: TypographyFonts.LIBRE_BODONI, fontStyle: 'italic', color: 'var(--black)', paddingTop: '72px' }}
                    tabletStyle={{ fontSize: '32px', paddingTop: '56px' }}
                    mobileStyle={{ fontSize: '26px', paddingTop: '0px' }}
                    dangerouslySetInnerHTML={{ __html: cardTitle }}
                  />
                )}
                {cardDescription && (
                  <Typography
                    variant={TypographyVariants.HEADING_3}
                    style={{ fontSize: '26px', fontWeight: '400', color: '#776644', marginTop: '18px' }}
                    tabletStyle={{ fontSize: '24px', marginTop: '12px' }}
                    mobileStyle={{ fontSize: '22px', marginTop: '12px' }}
                    className={styles.B2cPageCardSubTitle}
                    dangerouslySetInnerHTML={{ __html: cardDescription }}
                  />
                )}
              </Fragment>
            ),
            description: (
              <Fragment>
                <div className={`${styles.B2cPageCardDescription} position-relative`}>
                  <div className={styles.B2cPageCardRow}>
                    {featuresList.length > 0 && (
                      featuresList.slice(0, 2).map((feature, index) => {
                        const { cardTitle, cardDescription, cardImageUrl, cardImageUrlFallback, cardImageAlt, cardImageHeight, cardImageWidth } = feature;
                        return (
                          <Card key={index}
                            orientation={Orientation.VERTICAL}
                            imagePosition={{
                              mobile: Position.LEFT,
                              desktop: Position.LEFT
                            }}
                            alignment={{
                              justifyContent: FlexAlignment.FLEX_START,
                              alignItems: FlexAlignment.FLEX_START
                            }}
                            cardImage={{
                              className: styles.B2cPageCardImage,
                              imageUrl: cardImageUrl,
                              imageUrlFallback: cardImageUrlFallback,
                              imageAlt: cardImageAlt,
                              imageHeight: cardImageHeight,
                              imageWidth: cardImageWidth
                            }}
                            cardContent={{
                              className: styles.B2cPageCardContent,
                              title: (
                                cardTitle ? (
                                  <Typography
                                    variant={TypographyVariants.HEADING_4}
                                    className={styles.B2cPageCardTitle}
                                    style={{ fontSize: '24px', fontWeight: '700', fontFamily: TypographyFonts.AVENIR_NEXT, color: 'var(--black)', paddingTop: '0px', marginTop: '0px' }}
                                    tabletStyle={{ fontSize: '23px', paddingTop: '0px', marginTop: '0px' }}
                                    mobileStyle={{ fontSize: '22px', paddingTop: '0px', marginTop: '0px' }}
                                    dangerouslySetInnerHTML={{ __html: cardTitle }}
                                  />
                                ) : null
                              ),
                              description: (
                                cardDescription && (
                                  <Typography
                                    variant={TypographyVariants.PARAGRAPH}
                                    className={styles.B2cPageCardDescription}
                                    style={{ fontSize: '20px', fontWeight: '400', fontFamily: TypographyFonts.AVENIR_NEXT, color: 'var(--black)', paddingBottom: '0px', marginTop: '24px' }}
                                    tabletStyle={{ fontSize: '19px', paddingBottom: '0px', marginTop: '18px' }}
                                    mobileStyle={{ fontSize: '18px', paddingBottom: '0px', marginTop: '18px' }}
                                    dangerouslySetInnerHTML={{ __html: cardDescription }}
                                  />
                                )
                              )
                            }}
                            className={`${styles.B2cPageCard} ${styles.B2cPageCardColumn}`}
                          />
                        );
                      })
                    )}
                  </div>
                  <div className={styles.B2cPageCardRow}>
                    {featuresList.length > 0 && (
                      featuresList.slice(2, 4).map((feature, index) => {
                        const { cardTitle, cardDescription, cardImageUrl, cardImageUrlFallback, cardImageAlt, cardImageHeight, cardImageWidth } = feature;
                        return (
                          <Card key={index}
                            orientation={Orientation.VERTICAL}
                            imagePosition={{
                              mobile: Position.LEFT,
                              desktop: Position.LEFT
                            }}
                            alignment={{
                              justifyContent: FlexAlignment.FLEX_START,
                              alignItems: FlexAlignment.FLEX_START
                            }}
                            cardImage={{
                              className: styles.B2cPageCardImage,
                              imageUrl: cardImageUrl,
                              imageUrlFallback: cardImageUrlFallback,
                              imageAlt: cardImageAlt,
                              imageHeight: cardImageHeight,
                              imageWidth: cardImageWidth
                            }}
                            cardContent={{
                              className: styles.B2cPageCardContent,
                              title: (
                                cardTitle ? (
                                  <Typography
                                    variant={TypographyVariants.HEADING_4}
                                    className={styles.B2cPageCardTitle}
                                    style={{ fontSize: '24px', fontWeight: '700', fontFamily: TypographyFonts.AVENIR_NEXT, color: 'var(--black)', paddingTop: '0px', marginTop: '0px' }}
                                    tabletStyle={{ fontSize: '23px', paddingTop: '0px', marginTop: '0px' }}
                                    mobileStyle={{ fontSize: '22px', paddingTop: '0px', marginTop: '0px' }}
                                    dangerouslySetInnerHTML={{ __html: cardTitle }}
                                  />
                                ) : null
                              ),
                              description: (
                                <Typography
                                  variant={TypographyVariants.PARAGRAPH}
                                  className={styles.B2cPageCardDescription}
                                  style={{ fontSize: '20px', fontWeight: '400', fontFamily: TypographyFonts.AVENIR_NEXT, color: 'var(--black)', paddingBottom: '0px', marginTop: '24px' }}
                                  tabletStyle={{ fontSize: '19px', paddingBottom: '0px', marginTop: '18px' }}
                                  mobileStyle={{ fontSize: '18px', paddingBottom: '0px', marginTop: '18px' }}
                                  dangerouslySetInnerHTML={{ __html: cardDescription }}
                                />
                              )
                            }}
                            className={`${styles.B2cPageCard} ${styles.B2cPageCardColumn}`}
                          />
                        );
                      })
                    )}
                  </div>
                </div>
              </Fragment>
            )
          }}
          className={styles.B2cPageCard}
        />
      </section>
    );
  };

  const renderTalkToAnExpertContainer = () => {
    const { cardTitle, cardDescription, cardImageUrl, cardImageUrlFallback, cardImageAlt, cardImageHeight, cardImageWidth, buttonsList = [] } = expertSection || {};
    return (
      <section className={`${styles.TalkToAnExpertContainer} page-section-padding`}>
        <Card
          orientation={Orientation.HORIZONTAL}
          imagePosition={{
            mobile: Position.LEFT,
            desktop: Position.RIGHT
          }}
          alignment={{
            justifyContent: FlexAlignment.FLEX_START,
            alignItems: FlexAlignment.CENTER
          }}
          cardImage={{
            className: styles.B2cPageCardImage,
            imageUrl: cardImageUrl,
            imageUrlFallback: cardImageUrlFallback,
            imageAlt: cardImageAlt,
            imageHeight: cardImageHeight,
            imageWidth: cardImageWidth
          }}
          cardContent={{
            className: styles.B2cPageCardContent,
            title: (
              cardTitle ? (
                <Typography
                  variant={TypographyVariants.HEADING_2}
                  className={styles.B2cPageCardTitle}
                  style={{ fontSize: '36px', fontWeight: '700', fontFamily: TypographyFonts.LIBRE_BODONI, fontStyle: 'italic', color: 'var(--black)' }}
                  tabletStyle={{ fontSize: '32px' }}
                  mobileStyle={{ fontSize: '26px' }}
                  dangerouslySetInnerHTML={{ __html: cardTitle }}
                />
              ) : null
            ),
            description: (
              <Fragment>
                {cardDescription && (
                  <Typography
                    variant={TypographyVariants.HEADING_3}
                    style={{ fontSize: '26px', color: 'var(--black)', marginTop: '24px' }}
                    tabletStyle={{ fontSize: '24px' }}
                    mobileStyle={{ fontSize: '22px' }}
                    className={styles.B2cPageCardDescription}
                    dangerouslySetInnerHTML={{ __html: cardDescription }}
                  />
                )}
                {buttonsList.length > 0 && (
                  <div className={styles.B2cPageCardButtonsContainer}>
                    {buttonsList.map((button, index) => {
                      const { type, htmlType, linkUrl, openInNewTab, text, onClick } = button;
                      return (
                        <Button key={index} type={type} htmlType={htmlType} className={styles.B2cPageCardButton} linkUrl={linkUrl} openInNewTab={openInNewTab} onClick={onClick}>{text}</Button>
                      );
                    })}
                  </div>
                )}
              </Fragment>
            )
          }}
          className={styles.B2cPageCard}
        />
      </section>
    );
  };

  return (
    <main className={styles.B2cPageContainer}>
      {renderVirtualStoreContainer()}
      <PageDivider />
      {renderCustomerReviewContainer()}
      <PageDivider />
      {renderPersonalShoppingContainer()}
      {renderWhatsAppCommerceContainer()}
      {renderBlazingFastStoreSetupContainer()}
      {renderTalkToAnExpertContainer()}
    </main>
  );
};

export default B2cPage;
